import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowRedoDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-redo-down, forward"><path d="M17 19L21 15L17 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20 15L2.75 15L2.75 5.75L12.25 5.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowRedoDown;
